import { createFileRoute } from "@tanstack/react-router";
import { LoginForm } from "components/Forms/LoginForm/LoginForm.tsx";
import { AuthLink } from "components/UI/AuthLink/AuthLink.tsx";
import { AuthPageContainer } from "components/UI/AuthPageContainer/AuthPageContainer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

export const Route = createFileRoute("/auth/_layout/login/")({
    component: LoginPage,
});

function LoginPage() {
    const { t: tAuth } = usePaldockTranslation("auth.login");

    return (
        <AuthPageContainer title={tAuth("title")}>
            <LoginForm />
            <div className="flex justify-center mt-4 text-md text-black">
                {tAuth("messages.no_account")}{" "}
                <AuthLink to="/auth/registration" className="ml-1">
                    {tAuth("links.register")}
                </AuthLink>
            </div>
        </AuthPageContainer>
    );
}
